<script>
    export default {
        props: {
            variables: {
                validator: () => true,
                required: true
            }
        },
        watch: {
            variables () {
                this.$emit('change', this.variables)
            }
        },
        render () {
            return this.$scopedSlots.default(this.variables)
        }
    }
</script>
